<template>
   <div class="page-user-lsit">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">訂單</div>
         <div class="breadcrumb-item">訂單列表</div>
      </div>

      <div class="card-block">
         <div class="breadcrumb-item">篩選搜索</div>
         <br>
         <Form inline class="pg-form-inline form-input-wrap">

            <FormItem>
               <label class="input-label"
                      style="line-height: 19px;font-weight: 500;width: 64px;height: 22px;">取貨門店</label>
               <Select style="width: 200px;height: 40px;margin-right:50px;border-radius: 6px;" placeholder="全部"
                       v-model="form.pickup_address">
                  <Option :value="item.ReceivingName" v-for="(item, index) in pickAddress"
                          :key="item.ReceivingID">({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
               </Select>
            </FormItem>

            <FormItem>
               <label class="input-label"
                      style="line-height: 19px;font-weight: 500;width: 64px;height: 22px;">支付方式</label>
               <Select placeholder="全部" v-model="form.order_pay_type"
                       style="width: 200px;height: 40px;margin-right:50px;border-radius: 6px;">
                  <Option :value="1">積分</Option>
                  <Option :value="2">集金幣</Option>
                  <Option :value="3">其他</Option>
               </Select>
            </FormItem>
            <FormItem>
               <label class="input-label"
                      style="line-height: 19px;font-weight: 500;width: 64px;height: 22px;">訂單來源</label>
               <Select placeholder="全部" v-model="form.order_source"
                       style="width: 200px;height: 40px;border-radius: 6px;">
                  <Option :value="1">APP</Option>
                  <Option :value="3">第三方</Option>
               </Select>
            </FormItem>
            <br>
            <FormItem>
               <label class="input-label"
                      style="line-height: 19px;font-weight: 500;width: 64px;height: 22px;">訂單編號</label>
               <Input style="width: 200px;height: 40px;margin-right: 50px;border-radius: 6px;"
                      v-model="form.order_number" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <!-- <FormItem>
                 <label class="input-label" style="line-height: 19px;font-weight: 500;width: 64px;height: 22px;">商品名稱</label>
                 <Input style="width: 200px;height: 40px;margin-right: 50px;border-radius: 6px;" v-model="form.order_name" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem> -->
            <FormItem>
               <label class="input-label"
                      style="line-height: 19px;font-weight: 500;width: 64px;height: 22px;">用戶電話</label>
               <Input style="width: 200px;height: 40px;margin-right:50px;border-radius: 6px;" v-model="form.user_phone"
                      @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <DatePicker type="date" size="default" placeholder="起始日期" :options="options3" v-model="form.start_time"
                           value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
            </FormItem>
            <FormItem>-</FormItem>
            <FormItem>
               <DatePicker type="date" size="default" placeholder="結束日期" :options="options3" v-model="form.end_time"
                           value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
            </FormItem>
            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn"
                       style="line-height: 30px;font-size: 16px;width: 100px;height: 30px;border-radius: 6px;color: #FF466B"
                       @click="handleReset()">重置
                  </div>
                  <div class="pg-btn style2"
                       style="line-height: 30px;font-size: 16px;width: 100px;height: 30px;border-radius: 6px;"
                       @click="handleExport">導出
                  </div>
                  <div class="pg-btn style1"
                       style="line-height: 30px;font-size: 16px;width: 100px;height: 30px;border-radius: 6px;"
                       @click="handleSearch()">查詢搜索
                  </div>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">
         <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="全部" :name="String(0)"></el-tab-pane>
            <!-- <el-tab-pane label="待支付" :name="String(1)" ></el-tab-pane> -->
            <el-tab-pane label="待發貨" :name="String(2)"></el-tab-pane>
            <el-tab-pane label="已發貨" :name="String(3)"></el-tab-pane>
            <el-tab-pane label="到門店/智能櫃" :name="String(4)"></el-tab-pane>
            <el-tab-pane label="已完成" :name="String(5)"></el-tab-pane>
            <!-- <el-tab-pane label="已退款" :name="String(6)" ></el-tab-pane> -->
            <!-- <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin> -->

            <Table size="small"
                   :loading="isSubmiting"
                   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
               <template slot-scope="{ row, index }" slot="order_image">
                  <div class="demo-image__preview" @click="handlesrcList(row.order_image)">
                     <el-image
                        style="width: 80px; height: 70px"
                        :src="row.order_image"
                        :preview-src-list="srcList">
                     </el-image>
                  </div>
               </template>

               <template slot-scope="{ row, index }" slot="price">
                  <div class="pg-btn-wrap">
                     <div>積分：{{ row.order_amount_integral }}</div>
                     <div>集金幣：{{ row.order_amount_jpoint }}</div>
                  </div>
               </template>

               <template slot-scope="{ row, index }" slot="order_status">
                  <div class="pg-btn-wrap">

                     <!-- <div v-if="row.order_status == 0">待支付</div> -->
                     <div v-if="row.order_status == 3">待發貨</div>
                     <div v-if="row.order_status == 5">已發貨</div>
                     <div v-if="row.order_status == 7">到門店</div>
                     <div v-if="row.order_status == 9">已完成</div>
                     <!-- <div v-if="row.order_status == 11">已退款</div> -->

                  </div>
               </template>

               <template slot-scope="{ row, index }" slot="action">
                  <div class="pg-btn-wrap">

                     <div class="pg-btn style2" @click="handleDetail(row)">詳情</div>

                     <div class="pg-btn style1" @click="handleDesc(row)">备注</div>

                     <div v-if="row.order_status == 5 || row.order_status == 7 ||row.order_status == 9" class="
                        pg-btn style5" @click="handleLogistics(row)">物流
                     </div>

                     <div v-if="row.order_status == 3" class="pg-btn style2" @click="handleShip(row)">發貨</div>

                     <div v-if="row.order_status == 3 || row.order_status == 5" class="pg-btn style3"
                          @click="handlePrintCode(row)">打印
                     </div>

                     <!-- <div v-if="row.order_status == 3 || row.order_status == 5 || row.order_status == 7 ||row.order_status == 9" class="pg-btn style3" @click="handleReturn(row)">退貨</div> -->
                     <!-- <div v-if="row.order_status == 0 || row.order_status == 11" class="pg-btn style1" @click="handleDelete(row)">删除</div> -->
                  </div>
               </template>
            </Table>

            <div class="pg-pagger">
               <Row>
                  <Col span="12" class="pagger-left">
                     <div class="pagger-total">總共{{ totalCount }}條記錄</div>
                  </Col>
                  <Col span="12" class="pagger-right">
                     <div>
                        <div class="pagger-sizer">
                           <span>每頁</span>
                           <Select v-model="curPageSize" size="small" placeholder="數量"
                                   @on-change="handlePageSizeChange">
                              <Option :value="10">10</Option>
                              <Option :value="20">20</Option>
                              <Option :value="30">30</Option>
                              <Option :value="40">40</Option>
                              <Option :value="50">50</Option>
                           </Select>
                        </div>

                        <div class="pagger-elevator">
                           <span>跳轉</span>
                           <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                  @on-enter="handlePageEnter"/>
                        </div>

                        <Page size="small"
                              :current="pageIndex"
                              :page-size="curPageSize"
                              :total="totalCount"
                              @on-change="handlePageChange">
                        </Page>
                     </div>
                  </Col>
               </Row>
            </div>
         </el-tabs>
      </div>
      <Modal
         v-model="modal1"
         title="退貨退款"
         width="600"
         @on-ok="ok"
         @on-cancel="cancel">
         <div class="modal-cont">
            <!-- <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
                 <div class="loading-text">Loading</div>
             </Spin> -->
            <div class="pg-form-wrap">
               <Row>
                  <Col span="150" push="1">
                     <Form :label-width="160">
                        <Row>
                           <Col span="20">
                              <FormItem>
                                 <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>訂單金額</span>
                                 </div>
                                 <Input style="width: 100%"/>
                              </FormItem>
                              <FormItem>
                                 <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>退款説明</span>
                                 </div>
                                 <Input type="textarea" style="width: 100%"/>
                              </FormItem>
                           </Col>
                        </Row>
                     </Form>
                  </Col>
               </Row>
            </div>
         </div>
      </Modal>

      <Modal v-model="isShowModalSign_goods"
             title="物流信息"
             width="1200"
             :footer-hide="true"
             @on-cancel="handleModalSignClose_goods">
         <div class="modal-cont">
            <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
               <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
               <div class="loading-text">Loading</div>
            </Spin>
            <div class="step-wrap" v-if="detail && detail.length">
               <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
                  <div class="left">
                     <div class="l-date">
                        <span>{{ item.date }}</span>
                        <span>{{ item.week }}</span>
                     </div>
                     <div class="l-time">{{ item.time }}</div>
                  </div>
                  <div class="right">
                     <div class="r-address">{{ item.describe }} , 操作人：{{ item.userinfos }}</div>
                  </div>
               </div>
            </div>

            <div class="data-null" v-else>
               <!-- <img src="../../../assets/images/null-data.png" alt="" draggable="false"> -->
               <div>暫無數據</div>
            </div>
         </div>
      </Modal>
      <Modal v-model="showModal"
             title="備注"
             width="300"
             @on-ok="handleDescModal"
             @on-cancel="handleDescCancel">
         <Input type="textarea"
                autofocus
                style="margin-bottom: 18px;"
                :autosize="{minRows: 4}" v-model="desc"/>
      </Modal>
   </div>
</template>

<script>
import Store from '../../../assets/js/store.js';

export default {
   data() {
      return {
         detail: [],
         isSubmitingLog: false,
         isShowModalSign_goods: false,
         modal1: false,
         activeName: 0,
         srcList: [],
         pickAddress: [],
         pageIndex: 1,
         curPageSize: 10,
         pageInput: '',
         isSubmiting: false,
         totalCount: 0,
         status: false,
         showModal: false,
         order_number: '',
         desc: '',
         options3: {
            disabledDate(date) {
               return date && date.valueOf() > Date.now();
            }
         },
         form: {
            // order_name: '',
            order_number: '', //订单号
            order_source: '', //订单来源：1app，3第三方
            user_phone: '', //用户电话
            user_name: '', //用户姓名
            pickup_address: '', //门店名，传值必须是门店名称的字符串
            order_pay_type: '', //支付方式：1积分，2jpoint，3其他
            order_status: '', //订单状态：0待支付，3已支付，待发货5已发货7已到门店9已签收
            start_time: '',
            end_time: ''
         },
         table: {
            column: [
               // {
               //     type: 'selection',
               //     width: 60,
               //     align: 'center'
               // },
               {
                  title: '操作',
                  slot: 'action',
                  align: 'center',
                  minWidth: 200
               },
               {
                  title: '备注',
                  key: 'remark',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '訂單編號',
                  key: 'order_number',
                  align: 'center',
                  minWidth: 220
               },
               {
                  title: '訂單狀態',
                  slot: 'order_status',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '商品主圖',
                  key: 'order_image',
                  align: 'center',
                  slot: 'order_image',
                  sortable: true,
                  minWidth: 150
               },
               {
                  title: '商品名稱',
                  key: 'order_name',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '訂單數量',
                  key: 'order_num',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '訂單金額',
                  slot: 'price',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '用戶名稱',
                  key: 'user_name',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '用戶電話',
                  key: 'user_phone',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '取貨地址',
                  key: 'pickup_address',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '支付方式',
                  key: 'order_pay_type',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '訂單來源',
                  key: 'order_source',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '時間',
                  key: 'order_source',
                  align: 'center',
                  minWidth: 80
               },

            ],
            data: []
         }
      };
   },
   mounted() {
      this.getPickAddress();
      this.getList(this.activeName, 1, 10);
   },
   activated() {
      this.getPickAddress();
      this.getList(this.activeName);
   },
   methods: {
      handleDescCancel() {
         this.desc = ''
         this.order_number = ''
      },
      async handleDescModal() {
         const {code, msg} = await this.$Rq.requestAuth({
            url: this.$Api.commodityDesc,
            method: 'post',
            data: {
               remark: this.desc,
               order_number: this.order_number
            }
         })
         this.$message.success(msg)
         this.getList();
      },
      handleDesc(row) {
         row.order_number && (this.order_number = row.order_number)
         this.desc = ''
         this.showModal = true
      },
      handleExport() {
         /*
          order_number: '', //订单号
          order_source: '', //订单来源：1app，3第三方
          user_phone: '', //用户电话
          user_name: '', //用户姓名
          pickup_address: '', //门店名，传值必须是门店名称的字符串
          order_pay_type: '', //支付方式：1积分，2jpoint，3其他
          order_status: '', //订单状态：0待支付，3已支付，待发货5已发货7已到门店9已签收
          */
         let form = this.form
         let token = localStorage.getItem('jyb_token');
         let params = {
            'Authorization': token,
            order_status: form.order_status,
            order_pay_type: form.order_pay_type,
            pickup_address: form.pickup_address,
            user_phone: form.user_phone,
            user_name: form.user_name,
            order_number: form.order_number,
            // order_name: form.order_name,
            order_source: form.order_source,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
         };
         let formatParams = this.$Utils.formateObjToParamStr(params);
         if (form.start_time == '' || form.end_time == '') {
            this.$Utils.showTipInfo("請選擇開始時間和結束時間");
            return false;
         }
         let a = document.createElement('a')
         a.href = `${this.$Api.exportOrders}?${formatParams}`
         a.click()
      },

      handleReset() {
         this.form.order_number = '';
         // this.form.order_name = '';
         this.form.order_source = '';
         this.form.user_phone = '';
         this.form.user_name = '';
         this.form.pickup_address = '';
         this.form.order_pay_type = '';
         this.form.order_status = '';
         this.form.start_time = '';
         this.form.end_time = '';
      },
      getPickAddress() {
         this.$Rq.requestAuth({
            url: this.$Api.pickAddress,
            method: 'get',
            data: {
               company_id: 1,
            }
         }).then((res) => {
            if (res.code == 0) {
               this.pickAddress = res.data.data;
               // this.form.pickup_address = res.data.data[0].ReceivingName;
            }
         });
      },
      handlesrcList(imgobj) {
         this.srcList = [];
         for (let i = 0; i < imgobj.length; i++) {
            this.srcList.push(imgobj);
         }
      },
      handleClick(tab, event) {
         this.getList(tab.name, 1, 10);
      },
      getList(order_status, offset, limit) {
         let form = this.form;

         if (limit != undefined) {
            this.curPageSize = limit;
         }
         if (offset != undefined) {
            this.pageIndex = offset;
         }

         if (order_status == 0) {
            form.order_status = '';
         } else if (order_status == 1) {
            form.order_status = 0;
         } else if (order_status == 2) {
            form.order_status = 3;
         } else if (order_status == 3) {
            form.order_status = 5;
         } else if (order_status == 4) {
            form.order_status = 7;
         } else if (order_status == 5) {
            form.order_status = 9;
         } else if (order_status == 6) {
            form.order_status = 11;
         }

         this.isSubmiting = true;
         this.$Rq.requestAuth({
            url: this.$Api.orderUsersList,
            method: 'get',
            data: {
               order_status: form.order_status,
               order_pay_type: form.order_pay_type,
               pickup_address: form.pickup_address,
               user_phone: form.user_phone,
               user_name: form.user_name,
               order_number: form.order_number,
               // order_name: form.order_name,
               order_source: form.order_source,
               start_time: this.formatDate(form.start_time),
               end_time: this.formatDate(form.end_time),
               offset: (this.pageIndex - 1) * this.curPageSize,
               limit: this.curPageSize,
            }
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               let tempArr = [];
               let order_pay_type;
               let order_source;
               let resData = res.data.data;
               for (let i = 0; i < resData.length; i++) {

                  if (resData[i].order_pay_type == 1) {
                     order_pay_type = '積分';
                  } else if (resData[i].order_pay_type == 2) {
                     order_pay_type = '集金幣';
                  } else if (resData[i].order_pay_type == 5) {
                     order_pay_type = '集金幣/積分';
                  } else {
                     order_pay_type = '未支付';
                  }

                  if (resData[i].order_source == 1) {
                     order_source = 'APP';
                  } else if (resData[i].order_source == 3) {
                     order_source = '第三方';
                  }

                  tempArr.push({
                     goods_id: resData[i].goods_id, //商品的ID，用于跳转商品详情
                     order_amount_integral: resData[i].order_amount_integral, //订单金额积分支付的费用
                     order_amount_jpoint: resData[i].order_amount_jpoint, //订单金额Jpoint支付的费用
                     order_id: resData[i].order_id, //该笔订单的ID
                     order_image: resData[i].order_image, //商品主图
                     order_name: resData[i].order_name, //商品名称
                     order_num: resData[i].order_num, //该笔订单的数量
                     order_number: resData[i].order_number, //订单号
                     order_pay_type: order_pay_type, //订单支付类型
                     order_source: order_source, //订单来源
                     order_status: resData[i].order_status, //订单状态
                     pickup_address: resData[i].pickup_address, //门店地址
                     user_name: resData[i].user_name, //用户姓名
                     user_phone: resData[i].user_phone, //用户电话
                     remark: resData[i].remark, //备注
                  });
               }
               this.totalCount = res.data.count;
               this.table.data = tempArr;
            } else {
               this.totalCount = 0;
               this.table.data = [];
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },
      handleDelete(item) {
         let id = item.id;
         this.$Modal.confirm({
            title: '提示',
            content: '確定刪除嗎？',
            cancelText: '取消',
            okText: '確定',
            onOk: () => {
               let tableData = this.table.data;
               this.isSubmiting = true;
               this.$Rq.requestAuth({
                  url: this.$Api.commodityDelete,
                  method: 'post',
                  data: {
                     g_id: id
                  }
               }).then((res) => {
                  this.isSubmiting = false;
                  if (res.code == 0) {
                     this.$Utils.showSuccess(res.msg);
                     this.getList(this.activeName);
                  } else {
                     this.$Utils.showTipInfo(res.msg);
                  }
               }).catch((err) => {
                  this.isSubmiting = false;
               });
            }
         });
      },
      handleSearch() {
         this.pageIndex = 1;
         // this.activeName = String(0);
         this.getList(this.activeName, 1, 10);
      },
      handleDetail(item) {
         this.$router.push({path: '/orderdetailedList?id=' + item.order_number})
      },
      handleLogistics(item) {
         this.isShowModalSign_goods = true;
         this.isSubmitingLog = true;

         this.$Rq.requestAuth({
            url: this.$Api.logisticsInfo + '/' + item.order_number,
            method: 'get'
         }).then((res) => {
            this.isSubmitingLog = false;
            if (res.code == 0) {
               let resData = res.data;
               let tempArr = [];
               let userinfo;

               for (let i = 0; i < resData.length; i++) {
                  let datetime = this.getDateTime(resData[i].created_at);

                  if (resData[i].userinfos == null) {
                     if (resData[i].remarks.match(/[\u606d\u559c\u60a8]/g)) {
                        userinfo = '用戶線上支付';
                     } else {
                        if (resData[i].admin_name != null) {
                           userinfo = resData[i].admin_name;
                        } else {
                           userinfo = '智能櫃派送員';
                        }
                     }
                  } else {
                     userinfo = resData[i].userinfos.username;
                  }

                  tempArr.push({
                     userinfos: userinfo,
                     id: resData[i].id,
                     date: datetime.date,
                     week: datetime.week,
                     time: datetime.time,
                     describe: resData[i].remarks
                  });
               }

               this.detail = tempArr;
            }
         }).catch((err) => {
            this.isSubmitingLog = false;
         });
      },
      handlePrintCode(row) {
         let token = localStorage.getItem('jyb_token');

         this.$Rq.requestAuth({
            url: this.$Api.pickAddress,
            method: 'get',
            data: {
               company_id: 1,
               keywords: row.pickup_address
            }
         }).then((res) => {
            if (res.code == 0) {

               let params = {
                  odd_numbers: row.order_number,
                  arrive: res.data.data[0].ReceivingID,
                  amount: 0,
                  weight: 0,
                  size: 0,
                  long: 0,
                  wide: 0,
                  height: 0,
                  tel: row.user_phone,
                  arrive_type: res.data.data[0].Type,
                  abnormal_id: 0,
                  freight_collect: 0,
               };

               this.$Rq.requestAuth({
                  url: this.$Api.deliverCode2,
                  method: 'get',
                  data: params,
                  headers: {
                     responseType: 'blob'
                  }
               }).then(res => {
                  let blob = new Blob([res], {type: "text/html;charset=utf-8"})
                  let urlPdf = window.URL.createObjectURL(blob);
                  let newWindow = window.open(urlPdf, false);
                  if (window.print) {
                     newWindow.print();
                  }
                  newWindow.addEventListener('afterprint', function () {
                     newWindow.document.close();
                     window.URL.revokeObjectURL(urlPdf)
                     newWindow.close()
                  })
               })
            }
         }).catch(() => {
            this.isLoading = false;
         });
      },
      handleShip(row) {
         this.handlePrintCode(row);
         this.$Rq.requestAuth({
            url: this.$Api.orderExchangeShip,
            method: 'post',
            data: {
               order_numbers: row.order_number.split(',')
            }
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               this.$Utils.showSuccess(res.msg);
               this.activeName = String(3);
               this.getList(this.activeName, 1, 10);
            } else {
               this.$Utils.showTipInfo(res.msg);
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },
      handleReturn(row) {
         this.modal1 = true;
      },
      ok() {
         this.$Message.info('Clicked ok');
      },
      cancel() {
         this.$Message.info('Clicked cancel');
      },
      handlePageSizeChange(value) {
         this.pageIndex = 1;
         this.getList(this.activeName);
      },
      handlePageInput() {
         let value = ('' + this.pageInput).replace(/\D/g, '');
         let pageCount = Math.ceil(this.totalCount / this.curPageSize);
         if (value > pageCount) {
            value = pageCount;
         }
         this.pageInput = value;
      },
      handlePageEnter() {
         if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
         if (this.pageInput == 0) {
            this.pageInput = 1;
         }
         this.pageInput = parseInt(this.pageInput);
         this.pageIndex = this.pageInput;
         this.getList(this.activeName);
      },
      handlePageChange(value) {
         this.pageIndex = value;
         this.getList(this.activeName);
      },
      handleModalSignClose_goods() {
         this.isShowModalSign_goods = false;
      },
      getDetail() {
         this.isLoading = true;

         this.$Rq.requestAuth({
            url: this.$Api.logisticsInfo + '/' + this.pageParam.orderNo,
            method: 'get',
            data: {}
         }).then((res) => {
            this.isLoading = false;

            if (res.code == 0) {
               let resData = res.data;
               let tempArr = [];

               for (let i = 0; i < resData.length; i++) {
                  let datetime = this.getDateTime(resData[i].created_at);

                  tempArr.push({
                     userinfos: resData[i].userinfos == null ? '智能櫃' : resData[i].userinfos.username,
                     id: resData[i].id,
                     date: datetime.date,
                     week: datetime.week,
                     time: datetime.time,
                     describe: resData[i].remarks
                  });
               }

               this.detail = tempArr;
            }
         }).catch((err) => {
            this.isLoading = false;
         });
      },
      getDateTime(datetime) {
         let date = new Date(datetime);
         let year = date.getFullYear();
         let month = date.getMonth() + 1;
         let day = date.getDate();
         let hour = date.getHours();
         let minute = date.getMinutes();
         let second = date.getSeconds();
         let week = date.getDay();
         let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

         return {
            date: `${this.formateNum(year)}-${this.formateNum(month)}-${this.formateNum(day)}`,
            time: `${this.formateNum(hour)}:${this.formateNum(minute)}:${this.formateNum(second)}`,
            week: weekList[week]
         };
      },
      formateNum(num) {
         return num > 9 ? num : '0' + num;
      },
      formatDate(datetime) {
         if (!datetime) return '';
         let dateTime = new Date(datetime);
         let year = dateTime.getFullYear();
         let month = dateTime.getMonth() + 1;
         let date = dateTime.getDate();
         let hour = dateTime.getHours();
         let minute = dateTime.getMinutes();
         let second = dateTime.getSeconds();
         let milliseconds = dateTime.getMilliseconds();
         return `${this.formatNums(year)}-${this.formatNums(month)}-${this.formatNums(date)} ${this.formatNums(hour)}:${this.formatNums(second)}:${this.formatNums(milliseconds)}`;
      },
      formatNums(num) {
         return num < 10 ? '0' + num : num;
      },
   }
};
</script>

<style lang="scss" scoped>
@import 'orderList.scss';
</style>
